{% block sw_condition_value_content %}
    <div class="sw-condition-line-item sw-condition__condition-value">
        <sw-condition-operator-select v-bind="{ operators, condition }"></sw-condition-operator-select>
        <sw-single-select
                size="medium"
                :options="selectValues"
                id="reci-address-checker-rule"
                name="reci-address-checker-rule"
                v-model:value="isResponseValue"
                :allowEmpty="false"
                class="field--main">
        </sw-single-select>
    </div>
{% endblock %}
